module.exports = __webpack_public_path__ + "static/media/SegoeUI-Semibold.2b83a020.woff";